(function($){
	
	// Twitter
	var twWrapper = document.getElementById('tw-wrapper');

	if (typeof twWrapper !== 'undefined' && twWrapper != null) {

	var config = {
		"id": '717370614953156608',
		"domId": 'tw-wrapper',
		"maxTweets": 10,
		"enableLinks": true,
		"showUser": false,
		"showInteraction": true,
		"linksInNewWindow": true,
		"showPermalinks": false,
		"lang": 'es'
	};
	twitterFetcher.fetch(config);

	}
	
  // Masonry
  var $grid = $('.month-grid').imagesLoaded( function() {
	  $grid.masonry({
	    itemSelector: '.post',
			columnWidth: '.grid-sizer',
			percentPosition: true,
			transitionDuration: 0
	  });
	});
    
	// Section-header
	$(window).scroll(function(){
		var winST = $(window).scrollTop();
		var contentTop = parseInt($('.content-top').css('padding-top'));
		if (winST > contentTop) {
			$('.no-touch .section-header').fadeIn(250);
			$('.month').each(function(){
				var month = $(this).find('.month-title').text();
				var monthOffset = $(this).offset().top;
				var monthHeight = $(this).outerHeight();
				if(winST > monthOffset && winST < (monthOffset + monthHeight)) {
					$('.section-header').find('h2').text(month);
				}
			});
		} else {
			$('.no-touch .section-header').fadeOut(250);
		}
	});
	$('.section-header').hover(function(){
		$(this).fadeOut(250);
	});
	
	// Right Column
	var rightColumn = function() {
		$('right-column').imagesLoaded(function() {
			var columnWidth = $('.month-grid .grid-sizer').width();
			$('.right-column').width(columnWidth);
			var rcoffset = parseInt($('.right-column').css('top'));
			var rcheight = $('.right-column').outerHeight();
			var windowHeight = $(window).height();
			$(window).scroll(function() {
				var st = $(window).scrollTop();
				if ((rcoffset + rcheight) > windowHeight) {
					if ((st + windowHeight) > (rcoffset + rcheight)) {
						$('.right-column').addClass('fixed');
					} else {
						$('.right-column').removeClass('fixed');
					}
				} else {
					$('.right-column').addClass('fixed-top');
				}
			});
		});	
	}
	rightColumn();
	$(window).resize(rightColumn);
	
})(jQuery);
